<template>

    <div>
        <div class="modal fade" style="display: block; opacity: 1;" tabindex="-1" id="modalDeleteVehicle">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <a @click="closeModal" href="javascript:void(0)" class="close" data-dismiss="modal" aria-label="Close">
                    <em class="icon ni ni-cross"></em>
                </a>
                <div class="modal-header">
                    <h5 class="modal-title">Delete vehicle <span v-text="vehicleInfo.brand"></span> <span v-text="vehicleInfo.type"></span></h5>
                </div>
                <div class="modal-body">

                    <div id="form-edit-competitor">

                        <input type="hidden" name="vehicle_id" id="vehicle_id" v-model="vehicleInfo.id" />

                        <p>This action cannot be undone.</p>

                    </div>

                </div>
                <div class="modal-footer bg-light">
                    <button type="button" @click="closeModal" class="btn btn-light">Cancel</button>
                    <button type="button" @click="deleteVehicle" class="btn btn-danger">Delete</button>
                </div>
            </div>
        </div>
    </div>
        <div class="modal-backdrop fade show"></div>
    </div>

</template>

<script>
    export default {
        name: 'deleteVehicleModal',
        props: [
            'vehicle',
        ],

        data() {
            return {
                vehicleInfo: {},
            }
        },

        mounted() {
            this.vehicleInfo = this.vehicle;
        },

        methods: {
            deleteVehicle() {
                this.$emit('onDelete', this.vehicleInfo);
            },
            closeModal() {
                this.$emit('closeModal');
            }
        }
    }
</script>
